<template>
  <v-snackbar v-model="error.show" top :timeout="timeout">
    {{ error.msg }}
    <v-btn color="pink lighten-1" flat @click="error.show = false">
      Fechar
    </v-btn>
  </v-snackbar>
</template>
<script>
export default {
  data() {
    return {
      snackbar: false,
      timeout: 6000,
      msg: "Um erro ocorreu"
    };
  },
  computed: {
    error() {
      return this.$store.getters.snackbarError;
    }
  }
};
</script>
